export enum FramesActionTypes {
  CREATING = 'frames/CREATING',
  CREATED = 'frames/CREATED',
  INITIALIZED = 'frames/INITIALIZED',
  FETCHING = 'frames/FETCHING',
  RECEIVED = 'frames/RECEIVED',
  UPDATING = 'frames/UPDATING',
  UPDATED = 'frames/UPDATED',
}
